export const functionality = [
    { id: 'communityHub', name: 'Community Hub' },
    { id: 'eventListing', name: 'Event Listing' },
    { id: 'askAunty', name: 'Ask Aunty' },
    { id: 'worshipLocations', name: 'Worship Locations' },
];

export const type = [
    { id: 'content', name: 'Content' },
    { id: 'url', name: 'Link' },
    { id: 'functionality', name: 'Functionality' },
];
